
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Industries/retail-pos-billing-software",
      function () {
        return require("private-next-pages/Industries/retail-pos-billing-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Industries/retail-pos-billing-software"])
      });
    }
  